import { createMachine } from 'xstate';

export const blogListMachine = createMachine({
  id: 'blogList',
  initial: 'pending',
  states: {
    pending: {
      on: {
        RESOLVE: { target: 'resolved' },
        REJECT: { target: 'rejected' },
        EMPTY_RESPONSE: { target: 'emptyResponse' },
        FAIL_SEARCH: { target: 'unsuccessfulSearch' }
      }
    },
    resolved: {
      on: { DATA_CHANGE: { target: 'pending' } }
    },
    rejected: { on: { DATA_CHANGE: { target: 'pending' } } },
    unsuccessfulSearch: { on: { DATA_CHANGE: { target: 'pending' } } },
    emptyResponse: { on: { DATA_CHANGE: { target: 'pending' } } }
  }
});
